<nav tabindex="-1" id="menu" class="d-flex h-100 align-items-center justify-content-between bg-white navbar-color">
  <a routerLink="/" class="no-hover" aria-label="Retour à l'accueil" ngbTooltip="Retour à l'accueil" placement="bottom" container="body">
    <img height="24" src="/assets/libriciel_color.svg" alt=""/>
  </a>
  <div class="d-flex h-100">
    <app-navbar [allowedRnProducts]="allowedRnProducts"></app-navbar>
    <div class="d-none d-md-block h-auto separator m-3"></div>
    <a [routerLink]="[]" class="d-flex d-md-none" (click)="hideBurger = !hideBurger">
      <fa-icon size="lg" icon="bars"></fa-icon>
    </a>
    @if (profile | async; as p) {
      <div class="d-none d-md-flex h-100" routerLinkActive="active" ngbDropdown="dropdown"
        placement="bottom-end" display="static">
        <a href="javascript:void(0)" type="button" ngbDropdownToggle>
          <span
          class="ps-2"> {{ rolesService.isCollaborateur() ? keycloakService.getUsername() : p.firstName + ' ' + p.lastName }}</span>
        </a>
        @if (!rolesService.isCollaborateur()) {
          <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end"
            >
            <a routerLinkActive="active" routerLink="compte" ngbDropdownItem>
              <fa-icon icon="info-circle"></fa-icon>
              <span class="ps-2">Mon compte</span>
            </a>
            <div class="dropdown-divider"></div>
            <a routerLinkActive="active" routerLink="rgpd" ngbDropdownItem>
              <fa-icon icon="user-secret"></fa-icon>
              <span class="ps-2">Politique de confidentialité</span>
            </a>
            <a routerLink="aide" routerLinkActive="active" ngbDropdownItem>
              <fa-icon icon="question-circle"></fa-icon>
              <span class="ps-2">À propos - Aide</span>
            </a>
            <div class="dropdown-divider"></div>
            <a href="javascript:void(0)" ngbDropdownItem (click)="logout()">
              <fa-icon icon="sign-out-alt"></fa-icon>
              <span class="ps-2">Se déconnecter</span>
            </a>
          </div>
        } @else {
          <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right">
            <a href="javascript:void(0)" ngbDropdownItem (click)="logout()">
              <fa-icon icon="sign-out-alt"></fa-icon>
              <span class="ps-2"> Se déconnecter</span>
            </a>
          </div>
        }
      </div>
    } @else {
      <ls-spinner [scale]="0.3"></ls-spinner>
    }
  </div>
</nav>
<div [(ngbCollapse)]="hideBurger" class="burger-menu collapse hide" (click)="hideBurger=true">
  <a routerLink="">
    <fa-icon icon="home"></fa-icon>
    <span class="ps-2"> Accueil</span>
  </a>
  <a routerLink="informations" routerLinkActive="active">
    <fa-icon icon="bell"></fa-icon>
    <span class="ps-2"> Informations</span>
  </a>
  @if (!rolesService.isCollaborateur()) {
    <a [routerLink]="rolesService.hasProduct() ? 'tickets' : ''" [class]="rolesService.hasProduct() ? '': 'menu-disabled'"
      routerLinkActive="active">
      <fa-icon icon="sticky-note"></fa-icon>
      <span class="ps-2"> Mes tickets d'assistance</span>
    </a>
  }
  <a routerLink="faq" routerLinkActive="active">
    <fa-icon icon="comments"></fa-icon>
    <span class="ps-2"> FAQ</span>
  </a>
  <a routerLink="documentations" routerLinkActive="active">
    <fa-icon icon="file-pdf"></fa-icon>
    <span class="ps-2"> Documentations</span>
  </a>
  @for(p of allowedRnProducts; track p) {
    <a  [routerLink]="['notes-de-version', p.name]" routerLinkActive="active">
      <fa-icon icon="sticky-note"></fa-icon>
      <span class="ps-2"> Notes de version - {{p.name}}</span>
    </a>
  }
  @if (rolesService.isReferent() && rolesService.hasProduct()) {
    <a routerLink="prestations" routerLinkActive="active">
      <fa-icon icon="calendar"></fa-icon>
      <span class="ps-2"> Prestations</span>
    </a>
  }
  @if (rolesService.isReferent() && rolesService.hasProduct()) {
    <a routerLink="utilisateurs" routerLinkActive="active">
      <fa-icon icon="users"></fa-icon>
      <span class="ps-2"> Utilisateurs</span>
    </a>
  }
  @if (rolesService.isReferent() && rolesService.hasProduct()) {
    <a routerLink="contrats" routerLinkActive="active">
      <fa-icon icon="file-contract"></fa-icon>
      <span class="ps-2"> Contrats</span>
    </a>
  }
  <div class="dropdown-divider"></div>
  <a routerLinkActive="active" routerLink="compte">
    <fa-icon icon="info-circle"></fa-icon>
    <span class="ps-2"> Mon compte</span>
  </a>
  <div class="dropdown-divider"></div>
  <a routerLinkActive="active" routerLink="rgpd">
    <fa-icon icon="user-secret"></fa-icon>
    <span class=" ps-2"> Politique de confidentialité</span>
  </a>
  <a routerLink="aide" routerLinkActive="active">
    <fa-icon icon="question-circle"></fa-icon>
    <span class="ps-2"> À propos - Aide</span>
  </a>
  <div class="dropdown-divider"></div>
  <a href="javascript:void(0)" (click)="logout()">
    <fa-icon icon="sign-out-alt"></fa-icon>
    <span class="ps-2"> Se déconnecter</span>
  </a>
</div>
